<template>
  <ol class="c-webmention-list">
    <li
      v-for="{
        author,
        content,
        published,
        url,
        'wm-id': id,
      } in filteredWebmentions"
      :key="id"
      class="c-webmention-list__item"
    >
      <webmention-entry
        v-bind="{ id, author, content, published, url }"
      ></webmention-entry>
    </li>
  </ol>
</template>

<script>
import WebmentionEntry from '~/components/WebmentionEntry.vue';

export default {
  components: {
    WebmentionEntry,
  },

  props: {
    webmentions: {
      type: Array,

      required: true,
    },
  },

  computed: {
    filteredWebmentions() {
      return this.webmentions.filter(webmention =>
        ['in-reply-to', 'mention-of'].includes(webmention['wm-property']),
      );
    },
  },
};
</script>

<style lang="postcss">
.c-webmention-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.c-webmention-list__item {
  @nest & + .c-webmention-list__item {
    margin-top: var(--spacing-8);

    @media (--beta) {
      margin-top: var(--spacing-9);
    }
  }
}
</style>
